<template>
    <EmployeeTable></EmployeeTable>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const EmployeeTable = defineAsyncComponent(() =>
    import("../../components/Hr/EmployeeTable")
);

export default {
    name: "Employees",
    components: { EmployeeTable, AuthLayout },
};
</script>

<style scoped></style>
